// GB/T 23776-2018 (Chinese national standard, sensory evaluation of tea), Annex B (informative): weight of each factor
// per tea category. Factors: a appearance (dry_leaf), b liquor colour, c aroma, d taste, e infused leaf. Weights in %.
// The weighted score is out of 100: sum(weight * mark / 10) with our 0-10 marks (the standard grades 70-99).

export const GBT_CATEGORIES = ['green', 'gongfu_black', 'broken_black', 'oolong', 'dark', 'pressed', 'white', 'yellow', 'scented', 'tea_bag', 'powder'];

const F = ['dry_leaf', 'liquor_colour', 'aroma', 'taste', 'infused_leaf'];

export const GBT_WEIGHTS = {
  green: [25, 10, 25, 30, 10],
  gongfu_black: [25, 10, 25, 30, 10],
  broken_black: [20, 10, 30, 30, 10],
  oolong: [20, 5, 30, 35, 10],
  dark: [20, 15, 25, 30, 10],
  pressed: [20, 10, 30, 35, 5],
  white: [25, 10, 25, 30, 10],
  yellow: [25, 10, 25, 30, 10],
  scented: [20, 5, 35, 30, 10],
  tea_bag: [10, 20, 30, 30, 10],
  powder: [10, 20, 35, 35, null],     // no infused-leaf factor
};

// [{factor, weight}] of the factors that count for a category (powder has four)
export function gbtFactors(category) {
  const weights = GBT_WEIGHTS[category];
  if (!weights) return [];
  return F.map((factor, i) => ({ factor, weight: weights[i] })).filter((f) => f.weight !== null);
}

const scored = (v) => v !== null && v !== undefined && v !== '';

// Weighted score /100, only when every factor of the category is scored (null otherwise)
export function gbtWeightedScore(category, marks) {
  const factors = gbtFactors(category);
  if (!factors.length || factors.some(({ factor }) => !scored(marks[factor]))) return null;
  return factors.reduce((sum, { factor, weight }) => sum + (weight * Number(marks[factor])) / 10, 0);
}
